import { api } from "../lib/api";

// contentEngine.generateLookContent(finalLook)
export async function generateLookContent(finalLook) {
  const { data } = await api.post("/ai/generate-content", { finalLook });
  return data;
}
